export default "__VITE_ASSET__Hk0Qln_T__"